import moment from "moment-timezone";

/**
 * Header label for the schedule board. Day view shows the single date;
 * week view shows the Monday-start (ISO) week range containing it.
 * Owned by SchedulePage's reactive title — nothing else should write
 * the .schedule-board-date element.
 */
export function scheduleBoardDateLabel(
  start: string | Date | undefined,
  isWeekView: boolean
): string {
  const date = moment(start);
  if (!isWeekView) return date.format("ddd MMM Do, YYYY");

  const weekStart = date.clone().startOf("isoWeek");
  const weekEnd = date.clone().endOf("isoWeek");
  const sameMonth = weekStart.month() === weekEnd.month();
  const sameYear = weekStart.year() === weekEnd.year();
  // A week crossing a year boundary must show the year on both sides so the
  // start date isn't silently attributed to the end's year.
  const startFormat = sameYear ? "MMM D" : "MMM D, YYYY";
  const endFormat = sameMonth && sameYear ? "D, YYYY" : "MMM D, YYYY";
  return `${weekStart.format(startFormat)} – ${weekEnd.format(endFormat)}`;
}
